App.controller('HealthInsuranceInfoDocumentCtrl', ['$scope', '$sce', '$state', '$http', 'packageService', '$stateParams', function ($scope, $sce, $state, $http, packageService, $stateParams) {
    $scope.stateParams = $stateParams;

    $scope.page = 'healthInsuranceInfo_document';
    $scope.$emit('page', $scope.page);

    $scope.step = 'Dokumenty do pobrania';
    $scope.$emit('step', $scope.step);

    $scope.link = 'root.dashboard';
    $scope.$emit('link', $scope.link);
}]);
